<!-- EmptyState.vue -->
<script setup lang="ts">
import type { Component } from 'vue'
import { FileWaveIcon } from '@/icons/'
import BaseButton from '../Buttons/BaseButton.vue'

interface Props {
  icon?: Component
  title?: string
  description?: string
  hint?: string
  actionText?: string
  actionIcon?: Component
  onAction?: () => void
}

const props = withDefaults(defineProps<Props>(), {
  icon: FileWaveIcon,
  title: 'No items found',
  description: '',
  hint: '',
  actionText: '',
  actionIcon: undefined,
  onAction: undefined
})

const emit = defineEmits<{
  action: []
}>()

const handleAction = () => {
  if (props.onAction) {
    props.onAction()
  }
  emit('action')
}
</script>

<template>
  <div class="w-full flex flex-col items-center text-center py-8 gap-2">
    <component :is="icon" class="text-gray-400 w-12 h-12" />
    <div class="space-y-2">
      <p class="text-lg font-medium">{{ title }}</p>
      <p v-if="description" class="text-sm">{{ description }}</p>
      <p v-if="hint" class="text-xs ">{{ hint }}</p>
    </div>
    <BaseButton
      v-if="actionText"
      :text="actionText"
      size="sm"
      :icon="actionIcon"
      @click="handleAction"
    />
  </div>
</template>
